import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history'
import { Helmet, HelmetProvider } from 'react-helmet-async'

import './libs/yupInit'

import App from './App'
import AppProviders from './AppProviders'
import createQueryClient from './createQueryClient'
import reportWebVitals from './reportWebVitals'
import ENVIRONMENT from './config/environment'

import { register } from 'incident-solver/build/incident-solver'

const PLACES_API_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_PLACES_API_KEY}&libraries=places&language=es`

const main = async () => {
  if (ENVIRONMENT.hasMocks) {
    const { worker } = await import('./mocks/browser')
    worker.start()
  }

  const history = createBrowserHistory()
  const queryClient = createQueryClient()

  register()

  ReactDOM.render(
    <React.StrictMode>
      <HelmetProvider>
        <Helmet>
          <script async src={PLACES_API_URL}></script>
        </Helmet>
        <AppProviders history={history} queryClient={queryClient}>
          <App />
        </AppProviders>
      </HelmetProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  )
}

main()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
